import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'nguix-dashboard-home-page',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HomePage implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
